import React, { useEffect } from "react";

export default function PotentialBalanceTotals({
  potentialProfit,
  startBalance,
  potentialCashBalance,
  setPotentialCashBalance,
}) {
  useEffect(() => {
    setPotentialCashBalance({
      month1: Number(startBalance) + Number(potentialProfit.month1),
      month2:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2),
      month3:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3),
      month4:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4),
      month5:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5),
      month6:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6),
      month7:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7),
      month8:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7) +
        Number(potentialProfit.month8),

      month9:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7) +
        Number(potentialProfit.month8) +
        Number(potentialProfit.month9),
      month10:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7) +
        Number(potentialProfit.month8) +
        Number(potentialProfit.month9) +
        Number(potentialProfit.month10),
      month11:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7) +
        Number(potentialProfit.month8) +
        Number(potentialProfit.month9) +
        Number(potentialProfit.month10) +
        Number(potentialProfit.month11),
      month12:
        Number(startBalance) +
        Number(potentialProfit.month1) +
        Number(potentialProfit.month2) +
        Number(potentialProfit.month3) +
        Number(potentialProfit.month4) +
        Number(potentialProfit.month5) +
        Number(potentialProfit.month6) +
        Number(potentialProfit.month7) +
        Number(potentialProfit.month8) +
        Number(potentialProfit.month9) +
        Number(potentialProfit.month10) +
        Number(potentialProfit.month11) +
        Number(potentialProfit.month12),
    });
  }, [potentialProfit, startBalance]);

  return (
    <tr className="foot">
      <td className="alignLeft hideBorders hideBottomBorders">
        Potential Balance
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month1}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month2}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month3}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month4}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month5}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month6}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month7}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month8}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month9}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month10}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month11}
      </td>
      <td className="hideBorders hideBottomBorders">
        {potentialCashBalance.month12}
      </td>
    </tr>
  );
}
